export default {"src":"/_next/static/media/politics.664a37a6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};